import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import FJAnchor from './FJAnchor';
import classNames from 'classnames';
import FJUtil from '../../../util/FJUtil';
import FJDropDownManager from '../../js/FJDropDownManager';
import _ from 'lodash';
import './FJDropDown.less';
import FJEvent from '../../../store/FJEvent';
import { FJ_EVENT_TYPE } from '../../../constants/FJEvenTypeConstant';

class FJDropDown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            shown: false,
            left: 0,
            top: 0,
            placement: props.placement || 'bottomCenter',
        };
        this._isBindEvent = false;
        // 下拉菜单等级，1级面板，2级面板，3级面板...，默认为1级面板
        this._level = typeof props.level !== 'undefined' ? props.level : 1;
        if (!props.ignoreManager) this._id = FJDropDownManager.createId();
        // this.triggerEle = React.createRef(); // 使用 createRef
        // this.overlayEle = React.createRef(); // 使用 createRef
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.shown !== this.state.shown && this.props.updateActive) {
            this.props.updateActive(this.state.shown);
        }
        if (prevProps.active !== this.props.active && !this.props.active && !this.props.ignoreManager)
            FJDropDownManager.hide({ id: this._id, _level: this._level });
    }

    componentWillUnmount() {
        this._unbindEvent();
        if (!this.props.ignoreManager) FJDropDownManager.hide({ id: this._id, _level: this._level });
    }
    componentDidMount() {
        window.addEventListener('scroll', this._onScroll);
        FJEvent.subscribe(FJ_EVENT_TYPE.HIDE_ALL_DROP_DOWN, this.hide);
    }
    /**
     * @description 更新位置
     * @private
     */
    updateUI = () => {
        this._onResize();
    };

    _triggerMouseDown = e => {
        this.props.triggerMouseDown && this.props.triggerMouseDown(e);
    };
    _overlayEleMouseDown = e => {
        this.props.overlayEleMouseDown && this.props.overlayEleMouseDown(e);
    };

    _onTriggerEleClick = () => {
        this.props.onTriggerEleClick && this.props.onTriggerEleClick();
    };
    _overlayEleClick = e => {
        this.props.overlayEleClick && this.props.overlayEleClick(e);
    };

    _handleClick = e => {
        const { disabled, isNeedCallback = false, triggerClick } = this.props;
        if (disabled) return;
        const __click = () => {
            this.state.shown ? this.hide(e) : this.show();
        };
        if (triggerClick) {
            // triggerClick 可能会触发 closeColorDropDown 事件，但是当前被点击的 dropdown 也会接收到这个事件
            // 提前进入 hide，导致状态不正确，所以这里临时通过 _triggerClicked 来标记，是哪个 dropdown 被点击了
            // 后续如果要改，应该要重构一下这部分逻辑
            this._triggerClicked = true;
            triggerClick(isNeedCallback ? __click : undefined);
            this._triggerClicked = false;
        }
        if (!isNeedCallback) __click();
    };
    _show = e => {
        if (this.state.shown || this.props.disabled) return;
        this.setState({ shown: true }, () => {
            this._updateAfterShownChanged();
        });
    };
    show = () => {
        if (this.state.shown || this.props.disabled) return;
        if (!this.props.ignoreManager) {
            const { trigger = 'click' } = this.props;
            FJDropDownManager.show({
                id: this._id,
                trigger: trigger,
                level: this._level,
                checkCanBeHide: this._checkCanBeHide,
                hideFunction: this._hide,
                showFunction: this._show,
            });
        } else this._show();
    };
    _hide = e => {
        if (!this.state.shown || this.props.disabled) return;
        this.setState({ shown: false }, () => {
            this._updateAfterShownChanged(e);
        });
    };
    hide = e => {
        if (!this.state.shown || this._triggerClicked) return;
        if (!this.props.ignoreManager)
            FJDropDownManager.hide({ id: this._id, level: this._level, hideFunction: this._hide });
        else this._hide(e);
    };
    isShow = () => {
        return this.state.shown;
    };

    _hover = e => {
        e.stopPropagation();
        if (this.props.trigger !== 'hover' || this.state.shown) return;
        this.show(e);
    };

    // TODO 修改placement最终使用state，将展开后渲染在视窗内的适配集成到内部
    fitPosition = callback => {
        if (!this.getTriggerEle() || !this.getOverlayEle()) {
            return;
        }
        let triggerRect = this.getTriggerEle().getBoundingClientRect();
        let overlayRect = this.getOverlayEle().getBoundingClientRect();
        let left = 0;
        let top = 0;
        let defaultPlacement = this.props.placement || 'bottomCenter';
        let placement = defaultPlacement;
        const overlayRectH = overlayRect.height / 0.9; // 动画化回缩0.9倍
        switch (defaultPlacement) {
            case 'bottomLeft':
                left = triggerRect.left;
                top = triggerRect.top + triggerRect.height;
                break;
            case 'bottomCenter':
                left = triggerRect.left - overlayRect.width / 2 + triggerRect.width / 2;
                top = triggerRect.top + triggerRect.height;

                // 下面放不下但是上面放得下的情况
                if (
                    top + overlayRectH + 10 > document.documentElement.clientHeight &&
                    triggerRect.top - overlayRectH >= 10
                ) {
                    left = triggerRect.left - overlayRect.width / 2 + triggerRect.width / 2;
                    top = triggerRect.top - overlayRectH - 12;
                    placement = 'topCenter';
                }

                // 右边放不下的情况
                if (left + overlayRect.width + 10 > document.body.clientWidth) {
                    left = triggerRect.left - overlayRect.width + triggerRect.width + 8;
                    placement = 'bottomRight';
                }
                break;
            case 'bottomRight':
                left = triggerRect.left - overlayRect.width + triggerRect.width;
                top = triggerRect.top + triggerRect.height;
                break;
            case 'topLeft':
                left = triggerRect.left;
                top = triggerRect.top - overlayRectH;
                break;
            case 'topCenter':
                left = triggerRect.left - overlayRect.width / 2 + triggerRect.width / 2;
                top = triggerRect.top - overlayRectH;

                // 上面放不下但是下面放得下的情况
                if (
                    top < 10 &&
                    triggerRect.top + triggerRect.height + overlayRectH + 10 < document.documentElement.clientHeight
                ) {
                    left = triggerRect.left - overlayRect.width / 2 + triggerRect.width / 2;
                    top = triggerRect.top + triggerRect.height;
                    placement = 'bottomCenter';
                }

                break;
            case 'topRight':
                left = triggerRect.left - overlayRect.width + triggerRect.width;
                top = triggerRect.top - overlayRectH;
                break;
            case 'rightCenter':
                left = triggerRect.left + triggerRect.width;
                top = triggerRect.top + triggerRect.height / 2 - overlayRectH / 2;

                // 右边放不下的情况
                if (left + overlayRect.width + 10 > document.body.clientWidth) {
                    left = triggerRect.left - 10 - overlayRect.width;
                    placement = 'leftCenter';
                }

                break;
            case 'rightBottom':
                left = triggerRect.left + triggerRect.width;
                top = triggerRect.top + (triggerRect.height - overlayRectH);
                break;
            case 'rightTop':
                left = triggerRect.left + triggerRect.width;
                top = triggerRect.top;
                break;
            case 'leftCenter':
                left = triggerRect.left - overlayRect.width;
                top = triggerRect.top + triggerRect.height / 2 - overlayRectH / 2;
                break;
            default:
                left = triggerRect.left - overlayRect.width / 2 + triggerRect.width / 2;
                top = triggerRect.top + triggerRect.height;

                // 下面放不下但是上面放得下的情况
                if (
                    top + overlayRectH + 10 > document.documentElement.clientHeight &&
                    triggerRect.top - overlayRectH >= 10
                ) {
                    left = triggerRect.left - overlayRect.width / 2 + triggerRect.width / 2;
                    // TODO 删除12
                    top = triggerRect.top - overlayRectH - 12;
                    placement = 'topCenter';
                }
                break;
        }
        this.setState(
            {
                placement: placement,
                left: left,
                top: top,
            },
            () => {
                if (callback) callback();
                if (this.props.fitPositionCallback) {
                    this.props.fitPositionCallback();
                }
            },
        );
    };

    getTriggerEle = () => {
        return React.isValidElement(this.triggerEle) ? this.triggerEle : ReactDOM.findDOMNode(this.triggerEle);
    };
    getOverlayEle = () => {
        return React.isValidElement(this.overlayEle) ? this.overlayEle : ReactDOM.findDOMNode(this.overlayEle);
    };

    _updateAfterShownChanged = e => {
        let { onHide, onShow } = this.props;
        if (this.state.shown) {
            this._bindEvent();
            this._addShowAnimation();
            if (onShow) onShow();
        } else {
            this._unbindEvent();
            this._addHideAnimation();
            if (onHide) onHide(e);
        }
    };
    _bindEvent = () => {
        if (this._isBindEvent) return;
        let { trigger = 'click', hideEvent, ignoreManager } = this.props;
        if (hideEvent) window.addEventListener(hideEvent, this.hide);
        if (ignoreManager)
            document.body.addEventListener(trigger === 'click' ? 'mousedown' : 'mousemove', this._onMouseDown);
        window.addEventListener('resize', this._onResize);
        this._isBindEvent = true;
    };
    _unbindEvent = () => {
        if (!this._isBindEvent) return;
        let { trigger = 'click', hideEvent, ignoreManager } = this.props;
        if (hideEvent) window.removeEventListener(hideEvent, this.hide);
        if (ignoreManager)
            document.body.removeEventListener(trigger === 'click' ? 'mousedown' : 'mousemove', this._onMouseDown);
        window.removeEventListener('resize', this._onResize);
        this._isBindEvent = false;
    };
    _checkCanBeHide = e => {
        const isInTriggerArea = FJUtil.isPanelArea(e, this.getTriggerEle());
        const isInOverlayArea = FJUtil.isPanelArea(e, this.getOverlayEle());
        return !isInTriggerArea && !isInOverlayArea && this.state.shown;
    };
    _onMouseDown = e => {
        e.stopPropagation();
        // 如果没有点击到自身面板且没有点击到上层layer则隐藏面板
        if (this._checkCanBeHide(e)) {
            this.hide(e);
        }
    };
    _addShowAnimation = () => {
        let { animationInClass, animationOutClass } = this.props;
        let animationIn = animationInClass || 'c-drop-down-in';
        let animationOut = animationOutClass || 'c-drop-down-out';
        if (this.hideTimer) {
            clearTimeout(this.hideTimer);
        }
        this.overlayEle.classList.remove(animationOut);
        this.overlayEle.style.display = 'block';
        this.fitPosition(() => {
            this.overlayEle.classList.add(animationIn);
        });
    };
    _addHideAnimation = () => {
        let { animationInClass, animationOutClass } = this.props;
        let animationIn = animationInClass || 'c-drop-down-in';
        let animationOut = animationOutClass || 'c-drop-down-out';
        this.overlayEle.classList.remove(animationIn);
        this.overlayEle.classList.add(animationOut);
        this.hideTimer = setTimeout(() => {
            this.overlayEle.style.display = 'none';
            this.hideTimer = null;
        }, 90);
    };
    _onResize = () => {
        if (this.state.shown) {
            this._resizeDebounce =
                this._resizeDebounce ||
                _.debounce(() => {
                    this.fitPosition();
                }, 300);
            this._resizeDebounce();
        }
    };
    _onScroll = e => {
        if (this.state.shown) {
            this.hide(e);
        }
    };

    render() {
        let {
            overlay, //菜单
            overlayClassName,
            overlayStyle = {},
            isTopLayer,
            trigger = 'click', // click hover
            children,
            canTriggerActive,
            active = true,
            propsLeft,
            propsTop,
            disabled,
            triggerDisplay,
            zIndex,
        } = this.props;
        let { placement, shown, left, top } = this.state;
        if (propsLeft) {
            left += propsLeft;
        }
        if (propsTop) {
            top += propsTop;
        }
        let position = '';
        switch (placement) {
            case 'bottomLeft':
                position = 'c-overlay-bottom-left';
                break;
            case 'bottomCenter':
                position = 'c-overlay-bottom-center';
                break;
            case 'bottomRight':
                position = 'c-overlay-bottom-right';
                break;
            case 'topLeft':
                position = 'c-overlay-top-left';
                break;
            case 'topCenter':
                position = 'c-overlay-top-center';
                break;
            case 'topRight':
                position = 'c-overlay-top-right';
                break;
            case 'rightCenter':
                position = 'c-overlay-right-center';
                break;
            case 'rightBottom':
                position = 'c-overlay-right-bottom';
                break;
            case 'rightTop':
                position = 'c-overlay-right-top';
                break;
            case 'leftCenter':
                position = 'c-overlay-left-center';
                break;
            default:
                position = 'c-overlay-bottom-center';
                break;
        }
        let overlayClass = classNames('c-drop-down-box', overlayClassName, position);
        const childElement = React.Children.only(children);
        let display = triggerDisplay || 'inline-block';
        let cloneEle = React.cloneElement(childElement, {
            disabled,
            ref: el => (this.triggerEle = el),
            active: canTriggerActive ? (shown ? 'true' : '') : '',
            onClick:
                trigger === 'click'
                    ? e => {
                          if (e && e.stopPropagation) {
                              e.preventDefault();
                              e.stopPropagation();
                          }
                          this._onTriggerEleClick();
                          this._handleClick(e);
                      }
                    : e => {
                          if (e && e.stopPropagation) {
                              e.preventDefault();
                              e.stopPropagation();
                          }
                          this._onTriggerEleClick();
                      },
            onMouseOver: trigger === 'hover' ? this._hover : () => {},
            onMouseDown: this._triggerMouseDown,
            style: {
                ...childElement.props.style,
                display: active ? display : 'none',
            },
        });

        return (
            <Fragment>
                {cloneEle}
                <FJAnchor isTopLayer={isTopLayer} zIndex={zIndex}>
                    <div
                        className={overlayClass}
                        ref={ele => (this.overlayEle = ele)}
                        style={{
                            ...overlayStyle,
                            left: left,
                            top: top,
                        }}
                        onMouseDown={this._overlayEleMouseDown}
                        onClick={this._overlayEleClick}
                    >
                        {overlay}
                    </div>
                </FJAnchor>
            </Fragment>
        );
    }
}

export default FJDropDown;
